import React from "react";

import Page from "../components/Page";
import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";
import HourRegistrationForInvoices from "../components/HourRegistrationForInvoices";

const HourRegistrationForInvoicesPage = () => (
  <Page title="Urenregistratie voor facturen">
    <CenteredPageContentContainer>
      <PaperContainer title="Urenregistratie voor facturen">
        <HourRegistrationForInvoices />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default HourRegistrationForInvoicesPage;



// WEBPACK FOOTER //
// ./src/pages/HourRegistrationForInvoicesPage.js